<template>
  <v-dialog v-model="dialog.show" max-width="800">
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          sort-by="posicaoConsorcio"
          hide-default-footer
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          :page.sync="page"
        >
          <template v-slot:top>
            <v-row dense>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  v-model="search"
                  label="Procurar..."
                  prepend-inner-icon="mdi-magnify"
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.variacaoConsorcio="{ item }">
            <v-btn icon v-if="item.variacaoConsorcio > 0">
              <v-icon color="#75C00E">mdi-arrow-up-bold</v-icon>
              +{{ item.variacaoConsorcio }}
            </v-btn>
            <v-btn icon v-else-if="item.variacaoConsorcio < 0">
              <v-icon color="#DB2832">mdi-arrow-down-bold</v-icon>
              {{ item.variacaoConsorcio }}
            </v-btn>
          </template>

          <template v-slot:item.posicaoConsorcio="{ item }">{{ item.posicaoConsorcio }}ª</template>
        </v-data-table>
      </v-card-text>
      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogRankConsorcio",

  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dialog: {
        show: false,
        title: "Rank Consorcio"
      },
      headers: [
        { text: "", value: "variacaoConsorcio", sortable: false, align: "end" },
        {
          text: "Posição",
          value: "posicaoConsorcio",
          sortable: false,
          align: "center"
        },
        { text: "Empresa", value: "apelido", sortable: false, align: "center" },
        { text: "Nome", value: "nome", sortable: false, align: "start" },
        {
          text: "Quantidade",
          value: "consorcio",
          sortable: false,
          align: "center"
        }
      ],
      items: [],
      search: ""
    };
  },

  methods: {
    show(items) {
      this.dialog.show = true;
      this.items = [...items];
    }
  }
};
</script>
